import ProductDetailsActionTypes from '../actionTypes/ProductDetailsActionTypes';

const getProductDetailsAction = (payload) => ({
    type: ProductDetailsActionTypes.PRODUCTDETAILS_GET_REQUEST,
    payload,
});

const resetProductDetails = () => ({
    type: ProductDetailsActionTypes.PRODUCTDETAILS_RESET,
    payload: { sourceMiniPDP: true },
});

export default {
    getProductDetailsAction,
    resetProductDetails,
};
